export default "__VITE_ASSET__b29a1574__"